<script setup lang="ts">
import { t } from '@/i18next';

import { USER_CONTAINER_DELETE_WARNING } from '@/constants/alerts';

import type { ParseKeys } from 'i18next';

const props = defineProps<{
  alert: {
    alert: ParseKeys;
    isHTML: boolean;
  };
  entityType: ParseKeys;
}>();

const entityValue =
  props.alert.alert === USER_CONTAINER_DELETE_WARNING
    ? t(props.entityType)
    : t(props.entityType).toLowerCase();
</script>
<template>
  <span
    v-if="alert.isHTML"
    :data-testid="`single-alert-${alert.alert}`"
    v-html="
      $t(alert.alert, {
        entityType: entityValue
      })
    "
  />
  <span v-else :data-testid="`single-alert-${alert.alert}`">{{
    $t(alert.alert, {
      entityType: entityValue
    })
  }}</span>
</template>
